import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';

export interface ChangeApprovalRecord {
  id: string;
  transferOrderNumber: string;
  moveOutWarehouse: string;
  empathy: string;
  transferQuantity: number;
  remark: string;
  status: string;
  founder: string;
  creationTime: string;
}

export const CHANGE_APPROVAL_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'transferOrderNumber',
    label: 'inventory_change_approval.search_filter.transfer_order_number',
    type: 'text',
    placeholder: 'Please enter',
  },
  {
    key: 'status',
    label: 'inventory_change_approval.search_filter.status',
    type: 'select',
    placeholder: 'Please select',
    options: [
      { label: 'inventory_change_approval.status.pending', value: 'wait' },
      { label: 'inventory_change_approval.status.pending_execution', value: 'wait-execute' },
      { label: 'inventory_change_approval.status.executed', value: 'executed' },
      { label: 'inventory_change_approval.status.executed_failed', value: 'execute-fail' },
      { label: 'inventory_change_approval.status.failed', value: 'fail' },
      { label: 'inventory_change_approval.status.cancelled', value: 'cancel' },
    ],
  },
  {
    key: 'empathy',
    label: 'inventory_change_approval.search_filter.applicant',
    type: 'select',
    placeholder: 'Please select',
    options: [
      { label: 'John Smith', value: 'JOHN_SMITH' },
      { label: 'Sarah Johnson', value: 'SARAH_JOHNSON' },
      { label: 'Michael Brown', value: 'MICHAEL_BROWN' },
      { label: 'Emily Davis', value: 'EMILY_DAVIS' },
    ],
  },
  {
    key: 'moveOutWarehouse',
    label: 'inventory_change_approval.search_filter.transfer_out_of_empty_warehouse',
    type: 'select',
    placeholder: 'Please select',
    options: [
      { label: 'Warehouse A', value: 'WAREHOUSE_A' },
      { label: 'Warehouse B', value: 'WAREHOUSE_B' },
      { label: 'Warehouse C', value: 'WAREHOUSE_C' },
      { label: 'Warehouse D', value: 'WAREHOUSE_D' },
    ],
  },
  {
    key: 'creationTime',
    label: 'inventory_change_approval.table.columns.creation_time',
    type: 'dateRange',
    range: { startKey: 'startDate', endKey: 'endDate' },
  },
];

export const CHANGE_APPROVAL_TABLE_CONFIG: TableColumn[] = [
  { label: 'inventory_change_approval.table.columns.transfer_order_number', prop: 'transferOrderNumber', width: 180 },
  { label: 'inventory_change_approval.table.columns.source_warehouse', prop: 'moveOutWarehouse', width: 180 },
  { label: 'inventory_change_approval.table.columns.destination_warehouse', prop: 'empathy', width: 140 },
  { label: 'inventory_change_approval.table.columns.transfer_quantity', prop: 'transferQuantity', width: 140, styleClass: 'text-right' },
  { label: 'inventory_change_approval.table.columns.remark', prop: 'remark', width: 150 },
  { label: 'inventory_change_approval.table.columns.status', prop: 'status', width: 200, type: 'status' },
  { label: 'inventory_change_approval.table.columns.founder', prop: 'founder', width: 140 },
  { label: 'inventory_change_approval.table.columns.creation_time', prop: 'creationTime', width: 150, type: 'custom' },
  { label: 'inventory_change_approval.table.columns.action', prop: 'actions', type: 'actions', width: 160 },
];

export const CHANGE_APPROVAL_DEFAULT_CONFIG = {
  PAGE_SIZE: 20,
} as const;

export const CHANGE_APPROVAL_MESSAGES = {
  SUCCESS: {
    TRANSFER_APPROVED: 'Transfer approved successfully',
    TRANSFER_REJECTED: 'Transfer rejected successfully',
    DATA_EXPORTED: 'Data exported successfully',
  },
  ERROR: {
    DATA_LOAD_FAILED: 'Failed to load transfer data',
    APPROVAL_FAILED: 'Failed to approve transfer',
    REJECTION_FAILED: 'Failed to reject transfer',
    EXPORT_FAILED: 'Failed to export data',
  },
  CONFIRM: {
    APPROVE_TRANSFER: 'Are you sure you want to approve this transfer?',
    REJECT_TRANSFER: 'Are you sure you want to reject this transfer?',
    DELETE_TRANSFER: 'Are you sure you want to delete this transfer?',
  },
} as const;

export const TRANSFER_STATUS_COLORS = {
  wait: 'warning',
  'wait-execute': 'info',
  executed: 'success',
  'execute-fail': 'danger',
  cancel: 'secondary',
  fail: 'danger',
} as const;
